import { Field, FieldDescription, FieldLabel, IconBadge } from '@monksflow/monks-ui';
import { KnowledgeBaseFormFieldProps } from './KnowledgeBaseFormField.types';
import { useTranslation } from 'react-i18next';

export const KnowledgeBaseFormField = ({
  icon,
  title,
  description,
  required,
  children,
  fieldId,
  descriptionId,
}: KnowledgeBaseFormFieldProps) => {
  const { t } = useTranslation('knowledge');

  // eslint-disable-next-line i18next/no-literal-string -- element tag name
  const Heading = fieldId ? FieldLabel : 'p';

  return (
    <div className="overflow-auto pr-4" data-testid="knowledge-base-form-field">
      <div className="flex gap-4">
        <IconBadge variant="muted" size="default">
          {icon}
        </IconBadge>
        <Field className="w-full gap-3">
          <div className="flex flex-col gap-2">
            {/*
             * Read-only detail rows reuse this layout with no control of their own,
             * and a `<label>` that labels nothing is worse than a heading.
             */}
            <Heading
              {...(fieldId ? { htmlFor: fieldId, id: `${fieldId}-label` } : {})}
              className="text-base font-medium"
            >
              {title}
              {required && (
                <span
                  className="text-destructive"
                  aria-label={t('knowledgeBases.knowledgeBaseFormField.requiredField')}
                >
                  *
                </span>
              )}
            </Heading>
            {description && <FieldDescription id={descriptionId}>{description}</FieldDescription>}
          </div>
          {children}
        </Field>
      </div>
    </div>
  );
};

KnowledgeBaseFormField.displayName = 'KnowledgeBaseFormField';
